/**
* 入库操作 国内卡
*/
<template>

	<div style="margin: 20px 20px;">

		<!-- 数据加载提示框 -->
		<van-overlay :show="isDataLoading" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>

		<!-- 卡的数据 -->
		<el-descriptions title="卡" border style="padding-bottom: 60px;">
			<el-descriptions-item label="卡号">{{ iccid }}</el-descriptions-item>
			<el-descriptions-item label="卡类型">
				<el-tag size="small">国内卡</el-tag>
			</el-descriptions-item>
			<el-descriptions-item label="蓝牙地址">{{ mac }}</el-descriptions-item>
		</el-descriptions>

		<!-- 单卡在线信息实时查询 -->
		<el-descriptions title="单卡在线信息实时查询" border></el-descriptions>
		<el-table :data="API25M01List" stripe border style="width: 100%; flex: 1; overflow: auto;"
			:default-sort="{ prop: 'createTime', order: 'descending' }">
			<el-table-column prop="apnId" label="apnId" align="center"></el-table-column>
			<el-table-column prop="status" label="在线状态" align="center"></el-table-column>
			<el-table-column prop="ip" label="Ipv4地址" align="center"></el-table-column>
			<el-table-column prop="ipv6Prefix" label="ipv6前缀地址" align="center"></el-table-column>
			<el-table-column prop="ipv6" label="ipv6" align="center"></el-table-column>
			<el-table-column prop="createDate" label="会话创建时间" align="center"></el-table-column>
			<el-table-column prop="rat" label="接入方式" align="center"></el-table-column>
		</el-table>


		<!-- 单卡流量池内使用量实时查询 -->
		<el-descriptions title="单卡流量池内使用量实时查询" border style=" padding-top: 60px;"></el-descriptions>
		<el-table :data="API23U12List" stripe border style="width: 100%; flex: 1; overflow: auto;"
			:default-sort="{ prop: 'createTime', order: 'descending' }">
			<el-table-column prop="apnName" label="apn名称" align="center"></el-table-column>
			<el-table-column prop="apnUseAmount" label="流量用量(kb)" align="center"></el-table-column>
			<el-table-column prop="apnUseAmount001" label="流量用量(M)" align="center"></el-table-column>
			<el-table-column prop="apnUseAmount002" label="流量用量(G)" align="center"></el-table-column>
		</el-table>


		<!-- 检查单卡的开机状态 -->
		<el-descriptions title="检查单卡的开机状态" border style="padding-top: 60px;">
			<el-descriptions-item label="终端的开机状态">{{ API23U12_Status }}</el-descriptions-item>
		</el-descriptions>


		<!-- 批量查询卡单月GPRS流量使用量 -->
		<el-descriptions title="批量查询卡单月GPRS流量使用量" border style=" padding-top: 60px;"></el-descriptions>
		<el-button @click="getPreviousMonth()" type="text" size="small">上个月</el-button>
		<el-button @click="getNextMonth()" type="text" size="small">下个月</el-button>
		<ul>
			<li v-for="(data, index) in API25U03List" :key="index">
				<ul>
					<li v-for="(data01, index01) in data.apnDataAmountList" :key="index">
						<el-descriptions border>
							<el-descriptions-item label="Apn名称">{{ data01.apnName }}</el-descriptions-item>
							<el-descriptions-item label="Apn使用量(kb)">{{ data01.apnDataAmount }}</el-descriptions-item>
						</el-descriptions>
					</li>
				</ul>
			</li>
		</ul>


		<!-- 获取国内卡停机原因 -->
		<el-descriptions title="获取国内卡停机原因" border style="padding-top: 60px;">
			<el-descriptions-item label="物联卡对应的管理平台名称">{{ platformType }}</el-descriptions-item>
			<el-descriptions-item label="停机原因">{{ stopReason }}</el-descriptions-item>
		</el-descriptions>


		<!--  -->

	</div>

</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		data() {
			return {
				isDataLoading: false, //加载数据提示框
				iccid: "",
				mac: "",
				domesticToken: "", //国内卡token
				API25M01List: [], //单卡在线信息实时列表
				API23U12List: [], //单卡流量池内使用量实时列表
				API23U12_Status: "", //检查单卡开机状态0-关机 1-开机
				API25U03List: [], //批量查询卡单月GPRS流量使用量
				currentYearMonth: 0, //年+月份
				platformType: "", //物联卡对应的管理平台名称
				stopReason: "", //停机原因
			};
		},
		mounted() {
			this.iccid = this.$route.params.iccid;
			this.mac = this.$route.params.mac;

			this.getDomesticToken(); //获取国内物联卡信息查询准入
			//this.queryPackageInfo(); //查询iccid下可购买的套餐包
		},
		methods: {
			getDomesticToken() {
				this.isDataLoading = true;
				axios.get(this.$p_url + '/charge/4G/iccid/getDomesticToken', {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("获取国内物联卡信息查询准入的返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.domesticToken = response.data.data; //domesticToken
							this.queryCMIOT_API25M01(); //单卡在线信息实时查询
							this.queryCMIOT_API23U12(); //单卡流量池内使用量实时查询
							this.queryCMIOT_API25M00(); //检查单卡的开机状态的返回
							const currentDate = new Date();
							const year = currentDate.getFullYear();
							const month = currentDate.getMonth() + 1; // 月份从0开始，所以要加1
							this.currentYearMonth = `${year}-${this.formatMonth(month)}`;
							this.queryCMIOT_API25U03(); //批量查询卡单月GPRS流量使用量
							this.queryCMIOT_API25S02(); //获取国内卡停机原因
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},
			queryCMIOT_API25M01() {
				this.isDataLoading = true;
				axios.post(this.$p_url + '/charge/4G/iccid/CMIOT_API25M01', {
						iccid: this.iccid,
						domesticToken: this.domesticToken,
					}, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							//'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Content-Type': 'application/x-www-form-urlencoded', // 设置请求头为表单类型
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("单卡在线信息实时查询的返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.API25M01List = response.data.data.simSessionList; //单卡在线信息列表
							this.API25M01List.forEach(session => {
								session.status = this.getStatusText(session.status); // 处理 status 字段
								session.rat = this.getRatText(session.rat); // 处理 rat 字段
							});
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},
			queryCMIOT_API23U12() {
				axios.post(this.$p_url + '/charge/4G/iccid/CMIOT_API23U12', {
						iccid: this.iccid,
						domesticToken: this.domesticToken,
					}, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded', // 设置请求头为表单类型
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						console.log("单卡流量池内使用量实时查询的返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.API23U12List = response.data.data.apnList; //单卡流量池内使用量实时列表
							this.API23U12List.forEach(session => {
								session.apnUseAmount001 = session.apnUseAmount / 1024; // 转换为M
								session.apnUseAmount002 = session.apnUseAmount / 1024 / 1024; // 转换为G
							});
						}
					})
					.catch(error => { // 请求失败时处理错误
						console.error('Error fetching data:', error);
					});
			},
			queryCMIOT_API25M00() {
				axios.post(this.$p_url + '/charge/4G/iccid/CMIOT_API25M00', {
						iccid: this.iccid,
						domesticToken: this.domesticToken,
					}, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded', // 设置请求头为表单类型
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						console.log("检查单卡的开机状态的返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							if (response.data.data.status === "0") {
								this.API23U12_Status = "关机";
							} else {
								this.API23U12_Status = "开机";
							}
						}
					})
					.catch(error => { // 请求失败时处理错误
						console.error('Error fetching data:', error);
					});
			},
			queryCMIOT_API25U03() {
				const iccids0001 = [this.iccid];
				const currentYearMonth0001 = this.currentYearMonth.replace("-", '');
				axios.post(this.$p_url + '/charge/4G/iccid/CMIOT_API25U03', {
						iccids: iccids0001,
						queryDate: currentYearMonth0001,
						domesticToken: this.domesticToken,
					}, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						console.log("批量查询卡单月GPRS流量使用量的返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.API25U03List = response.data.data.dataAmountList;
						}
					})
					.catch(error => { // 请求失败时处理错误
						console.error('Error fetching data:', error);
					});
			},
			queryCMIOT_API25S02() {
				axios.post(this.$p_url + '/charge/4G/iccid/CMIOT_API25S02', {
						iccid: this.iccid,
						domesticToken: this.domesticToken,
					}, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded',
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						console.log("获取国内卡停机原因的返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.platformType = response.data.data.platformType; //物联卡对应的管理平台名称
							switch (response.data.data.stopReason) {
								case "000000000020":
									this.stopReason = "强制双向停机";
									break
								case "000000002000":
									this.stopReason = "主动申请双向停机";
									break
								case "000020000000":
									this.stopReason = "窄宽带商品到期失效停机";
									break
								case "020000000000":
									this.stopReason = "机卡分离停机";
									break
								case "000200000000":
									this.stopReason = "M2M管理停机";
									break
								case "000000000200":
									this.stopReason = "区域限制管理型停机";
									break
								case "000000000000":
									this.stopReason = "该卡不属于停机状态或系统暂无停机原因";
									break
								default:
									this.stopReason = response.data.data.stopReason;
									break
							}
						}
					})
					.catch(error => { // 请求失败时处理错误
						console.error('Error fetching data:', error);
					});
			},
			getPreviousMonth() {
				const [year, month] = this.currentYearMonth.split('-').map(Number);
				const previousMonth = month === 1 ? 12 : month - 1;
				const previousYear = month === 1 ? year - 1 : year;
				const result = `${previousYear}-${this.formatMonth(previousMonth)}`;
				this.currentYearMonth = result;
				this.queryCMIOT_API25U03();
			},
			getNextMonth() {
				const [year, month] = this.currentYearMonth.split('-').map(Number);
				const nextMonth = month === 12 ? 1 : month + 1;
				const nextYear = month === 12 ? year + 1 : year;
				const result = `${nextYear}-${this.formatMonth(nextMonth)}`;
				this.currentYearMonth = result;
				this.queryCMIOT_API25U03();
			},
			formatMonth(month) {
				return month.toString().padStart(2, '0');
			},
			getStatusText(status) {
				return status === '00' ? '离线' : (status === '01' ? '在线' : '未知状态');
			},
			getRatText(rat) {
				var string0001 = rat;
				switch (rat) {
					case "1":
						string0001 = "3G";
						break
					case "2":
						string0001 = "2g";
						break
					case "6":
						string0001 = "4G";
						break
					case "8":
						string0001 = "nb";
						break
					case "10":
						string0001 = "5G NAX";
						break
					case "51":
						string0001 = "5G SA";
						break
				}
				return string0001;
			},


		},
	};
</script>

<style>
</style>